import moment from 'moment-timezone';
import styles from './partnerProfile.module.scss';
const PartnerProfile = props => {
  const {
    partner
  } = props;
  const userAvatar = partner?.avatar || '/images/avatar.png';
  const timestamp = moment.tz(partner?.timezone).zoneAbbr() === 'GMT' ? '(GMT)' : `(GMT${moment.tz(partner?.timezone).zoneAbbr()})`;
  return <div className={styles.container}>
      <div className={styles.avatar}>
        <img src={userAvatar} alt="User avatar" />
      </div>
      <div className={styles.name}>{partner?.full_name}</div>

      {partner?.title && <div className={styles.position}>{partner?.title}</div>}
      {partner?.company && <div className={styles.position}>{partner?.company}</div>}
      <div className={styles.timestamp}>{`${timestamp} ${partner?.timezone}`}</div>
      {partner?.biography && <div className={styles.description}>{partner?.biography}</div>}
    </div>;
};
export default PartnerProfile;